(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gx-box-inhalt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gx-box-slider')) {
    customElements.define('gx-box-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.track = this.querySelector('.gx-box__track');
        this.nav = this.querySelector('.gx-box__nav');
        this.prev = this.querySelector('[data-gx-prev]');
        this.next = this.querySelector('[data-gx-next]');
        this.status = this.querySelector('[data-gx-status]');
        if (!this.track || !this.nav) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.prev.addEventListener('click', () => this.step(-1), options);
        this.next.addEventListener('click', () => this.step(1), options);
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.move(event.key === 'Home' ? 0 : this.maximum());
          }
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const cards = this.cards();
          const index = cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.move(index * this.stride(), true);
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.track);
        this.mutationObserver = new MutationObserver(() => this.scheduleUpdate());
        this.mutationObserver.observe(this.track, { childList: true });
        this.setAttribute('data-ready', '');
        this.update();
        if (this.dataset.dynamic === 'true') {
          const onVariant = variant => this.refreshVariant(variant?.id ?? variant);
          document.addEventListener('variant:change', event => onVariant(event.detail?.variant), options);
          document.addEventListener('variant:changed', event => onVariant(event.detail?.variant), options);
          document.addEventListener('change', event => {
            if (event.target.matches('[name="id"]')) onVariant(event.target.value);
          }, options);
          window.addEventListener('popstate', () => onVariant(new URL(location.href).searchParams.get('variant')), options);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => onVariant(event.data?.variant));
          }
        }
      }
      disconnectedCallback() {
        this.unsubscribe?.();
        this.requestAbort?.abort();
        this.abort?.abort();
        this.abort = null;
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
      async refreshVariant(value) {
        const id = String(value || '');
        if (!this.dataset.variantIds.split(',').includes(id)) return;
        // Cancel an older request even when the shopper switches back to the displayed variant.
        this.requestAbort?.abort();
        if (id === this.dataset.variant && !this.querySelector('[data-gx-load-error]:not([hidden])')) return;
        this.requestAbort = new AbortController();
        const request = this.requestAbort;
        const url = new URL(this.dataset.productUrl, location.origin);
        url.searchParams.set('variant', id);
        url.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Section response failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = html.getElementById(this.id);
          if (!incoming) throw new Error('Section missing');
          if (!request.signal.aborted && this.isConnected) this.replaceWith(incoming);
        } catch (error) {
          if (request.signal.aborted || !this.isConnected) return;
          this.track.hidden = true;
          this.querySelector('[data-gx-load-error]').hidden = false;
          const reload = new URL(this.dataset.productUrl, location.origin);
          reload.searchParams.set('variant', id);
          this.querySelector('[data-gx-reload]').href = reload.href;
          this.prev.disabled = this.next.disabled = true;
        }
      }
      cards() { return Array.from(this.track.querySelectorAll('.gx-box__card')); }
      maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
      position() {
        const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        return Math.max(0, Math.min(this.maximum(), this.track.scrollLeft * sign));
      }
      stride() {
        const card = this.cards()[0];
        return card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0) : 0;
      }
      step(direction) {
        const stride = this.stride();
        if (!stride) return;
        const position = this.position();
        const index = direction > 0 ? Math.floor((position + 2) / stride) + 1 : Math.ceil((position - 2) / stride) - 1;
        this.move(index * stride);
      }
      move(position, immediate = false) {
        const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: sign * Math.max(0, Math.min(position, this.maximum())), behavior: immediate || reduced ? 'auto' : 'smooth' });
        this.scheduleUpdate();
      }
      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }
      update() {
        const cards = this.cards();
        const max = this.maximum();
        const position = this.position();
        const overflow = max > 2;
        this.nav.hidden = false;
        this.prev.disabled = !overflow || position <= 2;
        this.next.disabled = !overflow || position >= max - 2;
        this.track.tabIndex = overflow ? 0 : -1;
        const trackRect = this.track.getBoundingClientRect();
        const visible = cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index }))
          .filter(({ rect }) => rect.right > trackRect.left + 2 && rect.left < trackRect.right - 2);
        if (visible.length) {
          const first = visible[0].index + 1;
          const last = visible[visible.length - 1].index + 1;
          const message = first === last ? `Karte ${first} von ${cards.length}` : `Karten ${first} bis ${last} von ${cards.length}`;
          if (this.status.textContent !== message) this.status.textContent = message;
        } else this.status.textContent = '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gx-collection-komplett"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gx-collection-complete')) {
    customElements.define('gx-collection-complete', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();

        const options = { signal: this.controller.signal };
        const form = this.querySelector('[data-gxc-form]');
        const sort = this.querySelector('[data-gxc-sort]');
        const disclosure = this.querySelector('[data-gxc-filters]');
        const mobileQuery = window.matchMedia('(max-width: 989px)');


        const description = this.querySelector('[data-gxc-description]');

        if (description) {
          const descriptionMobileQuery = window.matchMedia('(max-width: 749px)');
          const updateDescription = () => {
            description.open = !descriptionMobileQuery.matches;
          };

          updateDescription();
          descriptionMobileQuery.addEventListener('change', updateDescription, options);
        }

        if (disclosure) {
          disclosure.open = !mobileQuery.matches;

          mobileQuery.addEventListener('change', () => {
            disclosure.open = !mobileQuery.matches;
          }, options);
        }

        const priceGroups = Array.from(
          this.querySelectorAll('[data-gxc-price]')
        );

        const validatePrices = () => {
          priceGroups.forEach(group => {
            const min = group.querySelector('[data-gxc-min]');
            const max = group.querySelector('[data-gxc-max]');

            if (!min || !max) return;

            const invalidRange =
              min.value !== '' &&
              max.value !== '' &&
              Number(min.value) > Number(max.value);

            max.setCustomValidity(
              invalidRange
                ? 'Der Höchstpreis muss mindestens dem Mindestpreis entsprechen.'
                : ''
            );
          });
        };

        if (form) {
          form.addEventListener('input', validatePrices, options);

          form.addEventListener('invalid', event => {
            let parent = event.target.parentElement;

            while (parent && parent !== form) {
              if (parent.tagName === 'DETAILS') parent.open = true;
              parent = parent.parentElement;
            }
          }, { ...options, capture: true });

          form.addEventListener('submit', event => {
            validatePrices();

            if (!form.reportValidity()) {
              event.preventDefault();
              if (disclosure) disclosure.open = true;
            }
          }, options);

          form.addEventListener('formdata', event => {
            form.querySelectorAll('[data-gxc-price] input').forEach(input => {
              if (input.value === '') {
                event.formData.delete(input.name);
              }
            });
          }, options);
        }

        if (sort && form) {
          sort.addEventListener('change', () => {
            validatePrices();

            if (!form.checkValidity() && disclosure) {
              disclosure.open = true;
            }

            form.requestSubmit();
          }, options);
        }

        const faqItems = Array.from(
          this.querySelectorAll('[data-gxc-faq]')
        );

        faqItems.forEach(detail => {
          detail.addEventListener('toggle', () => {
            if (!detail.open || this.dataset.singleFaq !== 'true') return;

            faqItems.forEach(other => {
              if (other !== detail) other.open = false;
            });
          }, options);
        });

        document.addEventListener('shopify:block:select', event => {
          const detail = faqItems.find(
            item => item.dataset.blockId === event.detail?.blockId
          );

          if (!detail) return;

          if (this.dataset.singleFaq === 'true') {
            faqItems.forEach(other => {
              if (other !== detail) other.open = false;
            });
          }

          detail.open = true;
          detail.scrollIntoView({
            block: 'nearest',
            behavior: 'auto'
          });
        }, options);

        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gx-faq-kategorien"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gx-faq-categories')) {
    customElements.define('gx-faq-categories', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
        this.nav = this.querySelector('[data-faq-nav]');
        if (!this.tabs.length || !this.nav) return;
        this.nav.setAttribute('role', 'tablist');
        this.media = matchMedia('(max-width: 989px)');
        const orientation = () => this.nav.setAttribute('aria-orientation', this.media.matches ? 'horizontal' : 'vertical');
        orientation(); this.media.addEventListener('change', orientation, options);
        this.tabs.forEach(tab => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.hash.slice(1));
          tab.addEventListener('click', event => { event.preventDefault(); this.activate(tab.dataset.category); }, options);
          tab.addEventListener('keydown', event => {
            const next = this.media.matches ? 'ArrowRight' : 'ArrowDown';
            const prev = this.media.matches ? 'ArrowLeft' : 'ArrowUp';
            if (![next, prev, 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const index = this.tabs.indexOf(tab);
            let step = event.key === next ? 1 : -1;
            if (this.media.matches && getComputedStyle(this).direction === 'rtl') step *= -1;
            const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + step + this.tabs.length) % this.tabs.length;
            this.activate(this.tabs[target].dataset.category, true);
          }, options);
        });
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0;
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.category === panel.dataset.category).id);
          panel.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
            if (!detail.open || this.dataset.singleOpen !== 'true') return;
            panel.querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
          }, options));
        });
        document.addEventListener('shopify:block:select', event => {
          const detail = Array.from(this.querySelectorAll('[data-block-id]')).find(item => item.dataset.blockId === event.detail?.blockId);
          if (!detail) return;
          this.activate(detail.closest('[data-faq-panel]').dataset.category);
          if (this.dataset.singleOpen === 'true') detail.closest('[data-faq-panel]').querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
          detail.open = true;
          detail.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }, options);
        this.setAttribute('data-ready', '');
        const hashTab = this.tabs.find(tab => tab.hash === location.hash);
        this.activate(hashTab?.dataset.category || this.activeCategory || this.tabs[0].dataset.category);
      }
      activate(category, focus = false) {
        if (!this.tabs.some(tab => tab.dataset.category === category)) category = this.tabs[0].dataset.category;
        this.activeCategory = category;
        this.tabs.forEach(tab => {
          const active = tab.dataset.category === category;
          tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
          if (active && focus) { tab.focus({ preventScroll: true }); tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' }); }
        });
        this.panels.forEach(panel => {
          panel.hidden = panel.dataset.category !== category;
          if (!panel.hidden && this.dataset.openFirst === 'true' && !panel.querySelector('details[open]')) {
            const first = panel.querySelector('details'); if (first) first.open = true;
          }
        });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gx-faq-seite"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gx-faq-phases-v2')) {
    customElements.define('gx-faq-phases-v2', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const buttons = Array.from(this.querySelectorAll('[data-gxp-category]'));
        const groups = Array.from(this.querySelectorAll('[data-gxp-group]'));
        const items = Array.from(this.querySelectorAll('[data-gxp-item]'));

        const activate = phase => {
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gxpCategory === phase)));
          groups.forEach(group => { group.hidden = group.dataset.gxpGroup !== phase; });
        };

        buttons.forEach(button => button.addEventListener('click', () => activate(button.dataset.gxpCategory), options));

        items.forEach(item => item.addEventListener('toggle', () => {
          if (!item.open || this.dataset.singleOpen !== 'true') return;
          items.forEach(other => { if (other !== item) other.open = false; });
        }, options));

        if (buttons.length) activate(buttons[0].dataset.gxpCategory);

        document.addEventListener('shopify:block:select', event => {
          const item = items.find(detail => detail.dataset.blockId === event.detail?.blockId);
          if (!item) return;
          const group = item.closest('[data-gxp-group]');
          if (group) activate(group.dataset.gxpGroup);
          if (this.dataset.singleOpen === 'true') items.forEach(other => { if (other !== item) other.open = false; });
          item.open = true;
          item.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }, options);

        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gx-genuss-versprechen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gx-promise-section')) {
    customElements.define('gx-promise-section', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.dialog = this.querySelector('.gx-promise__dialog');
        this.trigger = this.querySelector('[data-gx-promise-open]');
        if (!this.dialog || !this.trigger) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.trigger.addEventListener('click', () => {
          if (!this.dialog.open) this.dialog.showModal();
        }, options);
        this.querySelector('[data-gx-promise-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.abort?.abort();
        this.abort = null;
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gx-qualitaetsmerkmale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gx-quality-page')) {
    customElements.define('gx-quality-page', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();this.controller = new AbortController();
        document.addEventListener('shopify:block:select', event => {
          const card=Array.from(this.querySelectorAll('[data-quality-block]')).find(item=>item.dataset.qualityBlock===event.detail?.blockId);
          if(!card)return;
          const details=card.querySelector('details');if(details)details.open=true;
          card.scrollIntoView({block:'nearest',behavior:'auto'});
        },{signal:this.controller.signal});
      }
      disconnectedCallback(){this.controller?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gx-versand-informationen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gx-shipping-section')) {
    customElements.define('gx-shipping-section', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.triggers = new Map();
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-gx-shipping-open]');
          if (trigger && this.contains(trigger)) {
            const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
            if (dialog && this.contains(dialog) && !dialog.open) {
              this.triggers.set(dialog, trigger);
              dialog.showModal();
            }
          }
          const close = event.target.closest('[data-gx-shipping-close]');
          if (close && this.contains(close)) close.closest('dialog')?.close();
        }, options);
        this.querySelectorAll('dialog').forEach((dialog) => {
          let pointerStartedOutside = false;
          const outside = (event) => {
            const rect = dialog.getBoundingClientRect();
            return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
          };
          dialog.addEventListener('pointerdown', (event) => {
            pointerStartedOutside = event.target === dialog && outside(event);
          }, options);
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog && pointerStartedOutside && outside(event)) dialog.close();
            pointerStartedOutside = false;
          }, options);
          dialog.addEventListener('close', () => {
            const trigger = this.triggers.get(dialog);
            if (trigger?.isConnected) trigger.focus({ preventScroll: true });
          }, options);
        });
        document.addEventListener('gox:lieferdatum', (event) => {
          if (!event.detail || !Object.prototype.hasOwnProperty.call(event.detail, 'value')) return;
          const date = typeof event.detail.value === 'string' ? event.detail.value.trim() : '';
          this.querySelectorAll('[data-gx-shipping-date]').forEach((node) => {
            node.querySelector('[data-gx-shipping-date-value]').textContent = date;
            node.hidden = !date;
          });
        }, options);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
        this.triggers?.clear();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
